<div class="cd-container">
  <div class="left-panel" [ngClass]="{'hidden-pane': hideLeftPane}">
    <div class="top-control" [style.box-shadow]="hideLeftPane ? 'none' : '0 1px 1px 0 grey'"
         [style.height]="selectedIndex > 0 ? '120px' : '220px'">
      <div class="top-filters">
        <div class="button-group-container">
          <ap-button class="ap-mr-spacing-3" [compact]="true" [btnType]="'tertiary'"
                     (onClick)="hideLeftPane = !hideLeftPane">
            <span class="Appkit4-icon icon-menu-outline"></span>
          </ap-button>
          <div class="btn-group-custom" [ngClass]="{'hidden': hideLeftPane}">
            @for (btn of btnGroupConfig; track $index; let i = $index) {
<ap-button
                       [label]="btn.buttonText"
                       [compact]="true"
                       [btnType]="selectedIndex === i ? 'primary' : 'secondary'"
                       [disabled]="!!btn.isDisabled"
                       (onClick)="btnChange(i)">
            </ap-button>
}
          </div>
        </div>
        <div class="dropdown-row row" [ngClass]="{'hidden': hideLeftPane}">
          <span class="col-md-2" style="line-height: 34px;">Tax Year</span>
          <div class="col-md-4">
            <ap-dropdown [list]="taxYears" [selectType]="'single'" [title]="selectorDefaultText"
                         [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYear"
                         (onSelect)="onTaxYearChanged($event)" style="width: 100%;">
              @for (item of taxYears; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                     [ariaLabel]="setAriaLabel(item, 'Tax Year')"
                                     (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
            </ap-dropdown>
          </div>
          <span class="col-md-2" style="line-height: 34px;">Tax Period</span>
          <div class="col-md-4">
            <ap-dropdown [list]="taxYearPeriods" [selectType]="'single'" [title]="selectorDefaultText"
                         [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Period'" [(ngModel)]="selectedPeriod"
                         (onSelect)="onPeriodChanged($event)" style="width: 100%;">
              @for (item of taxYearPeriods; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                     [ariaLabel]="setAriaLabel(item, 'Tax Period')"
                                     (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
            </ap-dropdown>
          </div>
        </div>
        @if (selectedIndex === 0) {
<div class="dropdown-row row" [ngClass]="{'hidden': hideLeftPane}">
          <span class="col-md-2" style="line-height: 34px;">Disclosure</span>
          <div class="col-md-10">
            <ap-dropdown [list]="disclosureTypes" [selectType]="'single'" [title]="selectorDefaultText"
                         [hideTitleOnInput]="true" [inputAriaLabel]="'Disclosure'" [(ngModel)]="selectedDisclosureType"
                         (onSelect)="onDisclosureTypeChanged($event)" style="width: 100%;">
              @for (item of disclosureTypes; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                     [ariaLabel]="setAriaLabel(item, 'Disclosure')"
                                     (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
            </ap-dropdown>
          </div>
        </div>
}
        @if (selectedIndex === 0) {
<div class="dropdown-row row" [ngClass]="{'hidden': hideLeftPane}">
          <span class="col-md-2" style="line-height: 34px;">Filter By</span>
          <div class="col-md-10">
            <ap-dropdown [list]="filterByTypes" [selectType]="'single'" [title]="selectorDefaultText"
                         [hideTitleOnInput]="true" [inputAriaLabel]="'Filter By'" [(ngModel)]="selectedfilterByType"
                         (onSelect)="onFilterByTypeChanged($event)" style="width: 100%;">
              @for (item of filterByTypes; track $index) {
<ap-dropdown-list-item #dropdownListItem [item]="item"
                                     [ariaLabel]="setAriaLabel(item, 'Filter By')"
                                     (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
}
            </ap-dropdown>
          </div>
        </div>
}
      </div>
    </div>

    <div class="list-container pr-0" [ngClass]="{'hidden': hideLeftPane}"
         [style.height]="selectedIndex > 0 ? 'calc(100% - 120px)' : 'calc(100% - 220px)'">
      <ap-search
        class="list-search"
        [searchType]="'secondary'"
        [placeholder]="'Search'"
        [disabled]="false"
        [filtered]="false"
        [isRecentSearch]="false"
        [(ngModel)]="searchTerm"
        (onClear)="clearSearchTerm()">
      </ap-search>
      @if (loadingData) {
<span>
        <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
      </span>
}

      @if (!loadingData && selectedFilterId !== 5) {
<div class="crt-disclosure-table">
        @if (formsFiltered.length == 0) {
<h5>No Data Found</h5>
}
        @if (formsFiltered.length > 0) {
<table class="ml-0">
          <thead>
          <tr>
            <th class="th-row1"><span>Disclosure</span></th>
            <th class="th-rown"><span>Primary</span></th>
            <th class="th-rown"><span>Secondary</span></th>
          </tr>
          </thead>
          <tbody>
          @for (form of formsFiltered | search : searchTerm; track $index) {
<tr>
            <td class="th-row1 pt-2 pr-2"><a href="javascript:void(0);" (click)="loadNewTab(form, true)"> {{ form.FORMNAME }} </a></td>
            <td class="th-rown pt-2 pr-2"><a href="javascript:void(0);" (click)="loadNewTab(form, true)"> {{ form.PRIMARYFORMTYPEDESC }} </a></td>
            <td class="th-rown pt-2"><a href="javascript:void(0);" (click)="loadNewTab(form, false)"> {{ form.SECONDARYFORMTYPEDESC }} </a></td>
          </tr>
}
          </tbody>
        </table>
}
      </div>
}
      @if (!loadingData && selectedFilterId === 5) {
<div class="crt-disclosure-table">
        @if (formsFiltered.length == 0) {
<h5 >No Data Found</h5>
}
        @if (formsFiltered.length > 0) {
<table class="ml-0">
          <thead>
            <tr>
              <th class="th-rowa"><span>Disclosure</span></th>
            </tr>
          </thead>  
          <tbody>
            @for (form of formsFiltered | search : searchTerm; track $index) {
<tr>
              <td class="th-rowa pt-2 pr-2"><a href="javascript:void(0);" (click)="downloadFile(form)"> {{ form.FORMNAME }} </a></td>
            </tr>
}
            </tbody>
        </table>
}
    </div>
}
    </div>

  </div>
  @if (!showCreateContainer) {
<div class="create-template-background" [ngClass]="{'hidden-pane': hideLeftPane}"></div>
}
  @if (showCreateContainer) {
<div class="create-template-container" [ngClass]="{'hidden-pane': hideLeftPane}">
    <dst-create-disclosure-shared></dst-create-disclosure-shared>
  </div>
}
</div>
